import { render, staticRenderFns } from "./ModalOrderDetail.vue?vue&type=template&id=5ab94da2"
import script from "./ModalOrderDetail.vue?vue&type=script&lang=js"
export * from "./ModalOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports